export default __webpack_public_path__ + "static/BrownStd-Regular-4abb299dd3ec34647391a41a03b1389a.woff";